var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-review-screen l-container section"},[_c('review-carousel',{attrs:{"title":_vm.title,"reviews":_vm.mappedReviews,"center-carousel":_vm.centerCarousel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }